var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonaiton3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.977,
    height: 32.502,
    viewBox: "0 0 30.977 32.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bank_account",
    "data-name": "bank account",
    d: "M30.953,14.191a1.523,1.523,0,0,0,1.524-1.524V8.1A1.522,1.522,0,0,0,31.435,6.65L17.721,2.079a1.527,1.527,0,0,0-.964,0L3.042,6.65A1.522,1.522,0,0,0,2,8.1v4.572a1.523,1.523,0,0,0,1.524,1.524H5.048V25.138A4.564,4.564,0,0,0,2,29.429v3.048A1.523,1.523,0,0,0,3.524,34H30.953a1.523,1.523,0,0,0,1.524-1.524V29.429a4.564,4.564,0,0,0-3.048-4.291V14.191ZM29.429,30.953H5.048V29.429a1.525,1.525,0,0,1,1.524-1.524H27.905a1.525,1.525,0,0,1,1.524,1.524ZM8.1,24.857V14.191h3.048V24.857Zm6.1,0V14.191h6.1V24.857Zm9.143,0V14.191h3.048V24.857ZM5.048,11.143V9.193L17.238,5.129,29.429,9.193v1.949Z",
    transform: "translate(-1.75 -1.748)",
    fill: "#b07f4a",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonaiton3);
export default __webpack_public_path__ + "static/media/donaiton3.45e09e827e14b993c5ab6bb39df8281d.svg";
export { ForwardRef as ReactComponent };